export default {
    home: {
        icon1:'稳定轻快',
        icon2:'通轴传动，稳定轻快',
        icon3:'节能高效',
        icon4:'比离合器电机省电75%',
        icon5:'兼容力强',
        icon6:'同种电控可兼容电动、气动多种机型',
        icon7:'机电一体',
        icon8:'独有的特色工艺',
        icon9:'故障急停',
        icon10:'保障缝制过程中损坏组件'
    },
    footer: {
        name: '版权所有',
        phone: '电话',
        time: '邮箱',
        address: '地址',
        copyright: 'icp备案',
        phoneContent: '0576-88177577',
        timeContent: '平日9：00-18：00',
        addressContent: '台州市椒江区下陈刘洋工业区',
        copyrightContent: '浙江百惠缝纫机有限公司  浙ICP备15035833号-1  公安备案号3310020200001',
        contact:'联系我们',
        mobile:'手机',
    },
    index: {
        about: '关于我们',
        about1: '浙江帕菲特缝纫机有限公司是一家定位于研发与生产高端特种装饰缝纫机，以生产小批量、多品种、高品质著称的专业性工厂。',
        about2: '同时不断研发，加大高端设备的投入，引进世界著名的设备厂商“MORI SEIKI”品牌的卧式加工中心、 立式加工中心、车铣复合式加工中心。“KITA MVR”精密车床以及“BROTHER”钻孔中心，“KENT”磨床。使其在机壳加工、零部件精度得到保证，开发出极具国际先进水平的曲牙机系列小圈绣对丝车系列以及拼缝四针六线系列产品。',
        about3: '公司坚持“做专、做精、做强”的核心理念，以缝纫机行业当中最具变化的机种—多针机为基础，成为品种最多，质量最好，产销量最大的生产企业。',
        look: '查看更多',
        product1: '研发与生产高端特种装饰缝纫机，以生产小批量、 多品种、高品质著称的专业性工厂',
        product2: '贴袋机',
        cowboy1: '研发与生产高端特种装饰缝纫机，以生产小批量、 多品种、高品质著称的专业性工厂',
        load: '彩页下载',
        companyProfile:"公司简介",
        companyProfileText:"美针牌工业缝纫机源自于德国品质的精工细作。 美针牌工业缝纫机依托中国浙江省在缝纫设备行业的绝对领先优势。集研发、生产销售、售后保障为一体，成为国际缝纫设备行业的先驱和领航者 。美针牌工业缝纫机，大中华区总代理：义乌市美针针车有限公司是浙江省义乌市缝纫设备同业工会会长单位，公司位于中国小商品城----浙江义乌，公司地理位置优越，交通便捷。公司经营进口、国产成套缝制设备，销售及收购各种进口、国产新旧缝制设备。",
        companyHonorsText1:"义乌市缝制机械 技术行业协会",
        companyHonorsText2:"我司于2021年荣获中国缝制设备行业协会、商贸委员会单位。",
    },
    message: {
        title: '标题',
        contacts: "联系人",
        phone: '电话',
        email: '邮箱',
        corporateName: '公司名称',
        corporateAddress: '公司地址',
        content: '内容',
        submit: '提交',
        mes: '您好，欢迎来到我们公司客户服务中心，请在此详细填写您所遇到的问题，并留下准确的Email地址和其他联系方式，我们的工作人员会在24小时内尽快给您回复。',
        placeholder1:'请输入标题',
        placeholder2:'请输入您的姓名',
        placeholder3:'请输入您的电话号码',
        placeholder4:'请输入您的邮箱',
        placeholder5:'请输入您的公司名称',
        placeholder6:'请输入您的公司地址',
        placeholder7:'请输入...',
        leave:'留言'
    },
    service:{
        before:'售前技术支持',
        beforeTitle:'个性化产品定制、网络化协同开发、信息化数据处理',
        nows:'售中产线跟踪',
        nowsTitle:'标准化过程控制、专业化安装指导、动态化品质追踪',
        after:'售后快修服务',
        afterTitle:'社区化服务模式、网购化服务体验、常态化服务培训'
    },
    product:{
        title1:'节能省电',
        mes1:'可比离合器电机节电75%',
        title2:'通轴传动',
        mes2:'稳定轻快，降低整机力矩，运行稳定',
        title3:'震动噪音',
        mes3:'噪音小, 不易产生疲劳提高工作效率',
    },
    about:{
        describe1:'研发经费持续投入,每年占销售总收入5%-8%',
        describe2:'授权专利',
        describe3:'公司员工',
        describe4:'厂房建筑面积'
    }
}
